import React from 'react';
import { Box, Typography } from '@mui/material';
import DOMPurify from 'dompurify';
import { contentToHtml } from '../../utils/adfToHtml';

export default function Comment({ comment, onReply }) {
  const { authorName, body, createdAt } = comment;
  const sanitized = DOMPurify.sanitize(contentToHtml(body || ''), { USE_PROFILES: { html: true } });
  const dateStr = createdAt
    ? new Intl.DateTimeFormat(navigator.language, { dateStyle: 'medium', timeStyle: 'short' }).format(new Date(createdAt))
    : '';

  return (
    <Box sx={{ mb: 2, pb: 2, borderBottom: 1, borderColor: 'divider' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
        <Typography component="span" fontWeight="bold">
          {authorName}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {dateStr}
        </Typography>
        {onReply && (
          <Typography
            component="button"
            variant="body2"
            color="primary"
            onClick={() => onReply()}
            sx={{ border: 'none', background: 'none', cursor: 'pointer', padding: 0 }}
            aria-label={`Reply to ${authorName}'s comment`}
          >
            Reply
          </Typography>
        )}
      </Box>
      <Box sx={{ mt: 0.5 }} dangerouslySetInnerHTML={{ __html: sanitized }} />
    </Box>
  );
}
